import {helpers} from 'vuelidate/lib/validators'

// validator using a regular expression
export const regExp = (pattern) => helpers.regex ('regExp', pattern)
